import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { ICustomer, ICustomerContact } from 'apps/fleet-planner/types'

interface IFetchCustomersParams {
  filters?: Record<string, any>
  pageNumber?: number
  pageSize?: number
  sortField?: string
  sortOrder?: string
}

export const FETCH_CUSTOMERS_ACTION_TYPES = generateApiActionTypes('FETCH_CUSTOMERS')
export const fetchCustomers = (params?: IFetchCustomersParams) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: FP_ENDPOINTS.customers,
      method: 'GET',
      params,
    },
    actionTypes: Object.keys(FETCH_CUSTOMERS_ACTION_TYPES),
  },
})

export const CREATE_CUSTOMER_ACTION_TYPES = generateApiActionTypes('CREATE_CUSTOMER')
export const createCustomer = (customer: Partial<ICustomer>) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: FP_ENDPOINTS.customers,
      method: 'POST',
      body: { customer },
    },
    actionTypes: Object.keys(CREATE_CUSTOMER_ACTION_TYPES),
  },
})

export const createCustomerSuccess = (customer: ICustomer) => ({
  type: CREATE_CUSTOMER_ACTION_TYPES.CREATE_CUSTOMER_SUCCESS,
  payload: {
    customer,
  },
})

export const UPDATE_CUSTOMER_ACTION_TYPES = generateApiActionTypes('UPDATE_CUSTOMER')
export const updateCustomer = (customerId: string, customer: Partial<ICustomer>) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: FP_ENDPOINTS.customers,
      method: 'PUT',
      id: customerId,
      body: { customer },
    },
    actionTypes: Object.keys(UPDATE_CUSTOMER_ACTION_TYPES),
  },
})

export const updateCustomerSuccess = (customer: ICustomer) => ({
  type: UPDATE_CUSTOMER_ACTION_TYPES.UPDATE_CUSTOMER_SUCCESS,
  payload: {
    customer,
  },
})

export const CREATE_CUSTOMER_CONTACT_ACTION_TYPES = generateApiActionTypes(
  'CREATE_CUSTOMER_CONTACT'
)
export const createCustomerContact = (
  customerId: string,
  customerContact: Partial<ICustomerContact>
) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: FP_ENDPOINTS.customers,
      method: 'POST',
      id: customerId,
      group: 'contacts',
      body: customerContact,
    },
    actionTypes: Object.keys(CREATE_CUSTOMER_CONTACT_ACTION_TYPES),
  },
})

export const createCustomerContactSuccess = (contact: ICustomerContact) => ({
  type: CREATE_CUSTOMER_CONTACT_ACTION_TYPES.CREATE_CUSTOMER_CONTACT_SUCCESS,
  payload: {
    contact,
  },
})

export const SET_CUSTOMER = 'SET_CUSTOMER'
export const setCustomer = (customer?: Partial<ICustomer>) => ({
  type: SET_CUSTOMER,
  payload: { customer },
})
